module.exports = __webpack_public_path__ + "static/media/manuel_de_gestion.f9cec289.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/gpi/documents/adhesion/manuel_de_gestion.pdf
// module id = 848
// module chunks = 40